import React, {memo, useCallback, useState} from 'react';
import cn from "classnames";
import styles from "./ButtonsScene.module.scss";
import WallIcon from "../../icons/WallIcon";
import {useStoreSystem} from "../../../store";
import shallow from "zustand/shallow";
import {SideType} from "../../../store/types/store";
import {getWallLineVertices} from './utils';
import {getCameraPositionToMiddleLine, getTargetPositionToMiddleLine} from '../../../store/helpers';
import {HorizontalLine20, VerticalLine38} from '../../SVGasComponent';


export const ChangeSideButtons = memo(() => {
    const [wallMenuIsOpen, setWallMenuIsOpen] = useState<boolean>(false);

    const { currentSide, setCurrentSide, setCurrentEditItem, setSystemProperties } = useStoreSystem(state => ({
        currentSide: state.currentSide,
        setCurrentSide: state.setCurrentSide,
        setCurrentEditItem: state.setCurrentEditItem,
        setSystemProperties: state.setSystemProperties,
    }), shallow);

    const handleToggleWallMenu = useCallback(() => {
        setWallMenuIsOpen((prevState) => !prevState)
    }, [])

    const handleChangeSide = (newSide: SideType) => () => {
        setWallMenuIsOpen(false)
        setCurrentSide(newSide);
        setCurrentEditItem(undefined, false);
        const lineVertices = getWallLineVertices(newSide);
        setSystemProperties([
            { name: 'targetZoom', value: 'wall' },
            { name: 'cameraPosition', value: getCameraPositionToMiddleLine(lineVertices) },
            { name: 'targetCameraPosition', value: getTargetPositionToMiddleLine(lineVertices) },

        ])
    }

    return (
        <>
            <div className={cn(styles.menu)}>
                <div
                    className={cn(styles.menuCard, styles.card, wallMenuIsOpen && styles.open, styles.row)}>
                    <button className={cn(styles.button, currentSide === 'front' && styles.active)}
                        onClick={handleChangeSide('front')}>
                        <WallIcon side="front" />
                    </button>
                    <VerticalLine38 />
                    <button className={cn(styles.button, currentSide === 'left' && styles.active)}
                        onClick={handleChangeSide('left')}>
                        <WallIcon side="left" />
                    </button>
                    <VerticalLine38 />
                    <button className={cn(styles.button, currentSide === 'back' && styles.active)}
                        onClick={handleChangeSide('back')}>
                        <WallIcon side="back" />
                    </button>
                    <VerticalLine38 />
                    <button className={cn(styles.button, currentSide === 'right' && styles.active)}
                        onClick={handleChangeSide('right')}>
                        <WallIcon side="right" />
                    </button>
                    <VerticalLine38 />
                    <button className={cn(styles.button, !wallMenuIsOpen && styles.active)}
                        onClick={wallMenuIsOpen ? handleChangeSide('top') : handleToggleWallMenu}>
                        <WallIcon side={wallMenuIsOpen ? 'top' : currentSide} />
                    </button>
                </div>
            </div>
            <HorizontalLine20 />
        </>
    );
})
